// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3gJxx","addWidgetButton":"Header_addWidgetButton__3LAa3","dashboardTabs":"Header_dashboardTabs__1ieG8","active":"Header_active__333I-"};